import React, { lazy, Suspense } from 'react';
import { Heading, HStack, VStack, Text } from 'native-base';

const AnimatedAvatar = lazy(
  () => import(/* webpackChunkName: "LazyAnimatedAvatar" */ './animated-avatar')
);

function AppDescriptionPanel() {
  return (
    <VStack space={{ base: 16, xl: 10 }}>
      <VStack space={1}>
        <Heading
          fontSize={{ base: '50px', lg: '40px', xl: '50px' }}
          key="random-heading"
          color={'primary.400'}
        >
          random
        </Heading>
        <Text>{'\n'}</Text>
        <HStack alignItems="baseline">
          <Heading
            fontSize={{ base: '50px', lg: '40px', xl: '50px' }}
            color={'red.200'}
          >
            an
          </Heading>
          <Suspense
            fallback={
              <span
                className="bold highlight"
                style={{
                  position: 'relative',
                }}
              >
                o
              </span>
            }
          >
            <AnimatedAvatar />
          </Suspense>
          <Heading
            fontSize={{ base: '50px', lg: '40px', xl: '50px' }}
            color={'red.200'}
          >
            nymous
          </Heading>
        </HStack>
        <Text>{'\n'}</Text>
        <Heading
          fontSize={{ base: '50px', lg: '40px', xl: '50px' }}
          lineHeight={{ base: '80px', lg: '80px' }}
          marginTop={{ base: '-20px', lg: '-15px' }}
          color={'orange.300'}
        >
          hyper-global
        </Heading>
      </VStack>

      <VStack space={5}>
        <Heading
          fontSize={{ base: '30px', md: '22px', lg: '25px' }}
          lineHeight={{ base: '50' }}
          color={'white'}
        >
          {'Migrate all over the world and find your flock.'}
        </Heading>

        <Text
          fontSize={{ base: 'xl', md: '18px', lg: '20px' }}
          lineHeight={50}
          color={'purple.300'}
        >
          No bots. No AI profiles. Just humans.
        </Text>
      </VStack>
    </VStack>
  );
}

const MemoAppDescriptionPanel = React.memo(AppDescriptionPanel);
export { MemoAppDescriptionPanel };
